import "./TrainingLegalFramework.module.css";
import EnTeteDeNavigation from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import WhyChooseEffetConseil from "./sections/WhyChooseEffetConseil";
import LesAccompagnements from "./sections/LesAccompagnements";
import Footer from "@/reusable_sections/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, ChevronDown } from "lucide-react";
const faqs = [{
  question: "Quand faut-il déclarer son activité\u00a0?",
  answer: "Au plus tard dans les trois mois suivant la conclusion de la première convention ou du premier contrat de formation professionnelle (art.\u00a0R.\u00a06351-1 du Code du travail)."
}, {
  question: "Un formateur indépendant sous-traitant doit-il avoir sa propre déclaration d'activité\u00a0?",
  answer: "Oui. Le sous-traitant dispose de son propre numéro de déclaration d'activité. Le donneur d'ordre reste seul responsable devant le client et le financeur, et vérifie avant l'intervention les titres et qualités du formateur."
}, {
  question: "La certification Qualiopi® protège-t-elle d'un contrôle\u00a0?",
  answer: "Non. Elle conditionne l'accès à certains financements et ne se substitue à aucun contrôle de l'État, des financeurs ou de France Compétences."
}, {
  question: "Que risque un organisme depuis la loi du 25\u00a0juin 2026\u00a0?",
  answer: "Une amende administrative jusqu'à 4\u00a0000\u00a0€ par manquement (2\u00a0000\u00a0€ pour le passeport de prévention), le remboursement des sommes perçues lorsque l'action est réputée inexécutée, et la publicité possible de certaines sanctions."
}, {
  question: "Faut-il modifier son règlement intérieur\u00a0?",
  answer: "Oui, pour les organismes qui mobilisent des fonds publics ou mutualisés\u00a0: il intègre l'égalité de traitement des stagiaires et apprentis, le respect de leur liberté d'expression et de conscience et la neutralité des enseignements (art.\u00a0L.\u00a06352-4 du Code du travail)."
}];
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(faq => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer
    }
  }))
};
function FaqCadreJuridique() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    once: true
  });
  return <section id="faq-cadre-juridique" className="w-full bg-[#F5EDE8] py-16 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} />
      <div ref={ref} className={`max-w-4xl mx-auto px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4 !text-[hsl(210,10%,23%)]">
          Questions fréquentes
        </h2>
        <p className="font-sans text-sm mb-8 text-[hsl(210,10%,23%)]/70">
          Les informations publiées sur cette page sont générales et ne
          constituent pas une consultation juridique.
        </p>
        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => <details key={index} data-index={index} className="group bg-white rounded-sm border border-[#d6cfc4]/60 shadow-sm">
              <summary className="flex items-center justify-between gap-4 cursor-pointer list-none [&::-webkit-details-marker]:hidden px-6 py-4 font-serif text-lg font-semibold text-[hsl(343,80%,35%)]">
                {faq.question}
                <ChevronDown className="size-5 shrink-0 transition-transform duration-200 group-open:rotate-180" aria-hidden="true" />
              </summary>
              <p className="px-6 pb-5 font-sans text-base leading-relaxed text-[hsl(210,10%,23%)]">
                {faq.answer}
              </p>
            </details>)}
        </div>
      </div>
    </section>;
}
function ContactCtaCadreJuridique() {
  return <section id="contact-cadre-juridique" className="w-full bg-[hsl(343,50%,18%)] py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
        <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6 text-white leading-tight">
          Votre activité est-elle conforme aux textes en vigueur&nbsp;?
        </h2>
        <p className="font-sans text-lg md:text-xl text-white/80 mb-10 max-w-2xl">
          Diagnostic de conformité, revue documentaire, veille
          réglementaire&nbsp;: échangeons sur votre situation, en toute
          confidentialité.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="!bg-[hsl(343,80%,35%)] text-white hover:!bg-[hsl(343,80%,30%)] rounded-sm font-sans text-base px-8 h-12 shadow-xl">
            <a href="https://effet-conseil.com/rdv/">
              Prendre rendez-vous
              <ArrowRight className="ml-2 size-5" />
            </a>
          </Button>
          <Button asChild size="lg" variant="outline" className="!bg-transparent border-2 border-white/60 text-white hover:!bg-white/10 hover:text-white rounded-sm font-sans text-base px-8 h-12">
            <Link to="/contact/">Écrire à Effet Conseil</Link>
          </Button>
        </div>
      </div>
    </section>;
}
export default function TrainingLegalFrameworkPage() {
  return <div>
      <EnTeteDeNavigation />
      <Hero />
      <WhyChooseEffetConseil />
      <LesAccompagnements />
      <FaqCadreJuridique />
      <ContactCtaCadreJuridique />
      <Footer />
    </div>;
}